<app-heading [title]="helperService.capitalizeFirstLetter('Published') + ' Jobs'" [showToggle]="false"></app-heading>
<div class="wrap-project-details">
    <div class="wrap-doc-details">
        <div class="name">
            <span>{{job.title}}</span>
        </div>
        <div class="date-position">
            <p class="m-0">Start Date: {{job?.startDate | date:'MM/dd/yyyy' }}</p>
            <p class="m-0">Published: {{job?.publishedAt | date:'MM/dd/yyyy' }}</p>
        </div>
    </div>

   
    <div class="flex justify-content-end align-items-center mb-3 ">
        <button pButton [text]="true" pTooltip="Edit" tooltipPosition="top" class=" button-edit-job p-button-rounded p-button-text" (click)="onEditJob($event, job)">
            <span class="{{helperService.getEnvironmentName()}}-icon icon-edit-outlined"></span>
        </button>
    </div>
</div>
<p-tabView styleClass="full-w">
    <p-tabPanel header="Candidate">
        <app-candidates-tab [jobId]="jobId"></app-candidates-tab>
    </p-tabPanel>
    <p-tabPanel header="Details">
        <app-details-tab [jobDetails]="job"></app-details-tab>
    </p-tabPanel>
</p-tabView>
